require('./RASaveSimulationModal.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

class RASaveSimulationModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleEditSaveSimulation = this.handleEditSaveSimulation.bind(
            this,
        );
        this.getParentSelector = this.getParentSelector.bind(this);
        this.handleCloseSaveSimulation = this.handleCloseSaveSimulation.bind(
            this,
        );
        this.handleDeleteSaveSimulationFlow = this.handleDeleteSaveSimulationFlow.bind(
            this,
        );
    }

    getParentSelector() {
        return document.querySelector('.app__container');
    }

    handleDeleteSaveSimulationFlow() {
        const {
            deleteSimulation,
            onModalClose,
            resetValueOfSaveSimulation,
            isObjective,
            immSaveSimulation,
        } = this.props;
        const simulationId = isObjective
            ? immSaveSimulation.getIn([
                  'saveSimulationObjective',
                  'simulationId',
              ])
            : immSaveSimulation.getIn([
                  'saveSimulationPortfolio',
                  'simulationId',
              ]);
        deleteSimulation(simulationId);
        onModalClose();
        resetValueOfSaveSimulation();
    }

    handleCloseSaveSimulation() {
        this.handleDeleteSaveSimulationFlow();
    }

    handleEditSaveSimulation() {
        this.props.onModalClose();
    }

    buildDescription() {
        const { isObjective, immSaveSimulation } = this.props;
        let typeOfStategy = isObjective
            ? immSaveSimulation.getIn(['saveSimulationObjective', 'name'])
            : Portfolios[
                  immSaveSimulation.getIn([
                      'saveSimulationPortfolio',
                      'newProfile',
                  ])
              ];
        if (typeOfStategy && typeOfStategy.portfolioName) {
            typeOfStategy = typeOfStategy.portfolioName;
        }
        const strategyGoalNameComponent = (
            <span className="ra-save-simulation-modal__description--bold">
                {typeOfStategy}
            </span>
        );
        const descriptionText = isObjective
            ? 'raSaveSimulationModel-objectiveDescription'
            : 'raSaveSimulationModel-portfolioDescription';
        return (
            <FormattedTextWithComponents
                className="ra-save-simulation-modal__description-font"
                value={descriptionText}
                injectedComponents={[strategyGoalNameComponent]}
            />
        );
    }

    render() {
        const { isModalOpen } = this.props;
        const description = this.buildDescription();
        const contentModal = (
            <div className="ra-save-simulation-modal__parent-div">
                <div className="ra-save-simulation-modal__title">
                    {' '}
                    <FormattedText value="raSaveSimulationModel-title" />{' '}
                </div>
                <div className="ra-save-simulation-modal__description">
                    {description}
                </div>
                <div className="ra-save-simulation-modal__buttons">
                    <div className="ra-save-simulation-modal__save-button">
                        <OKButton
                            modifier="secondary"
                            onClick={this.handleDeleteSaveSimulationFlow}
                        >
                            <FormattedText value="raSaveSimulationModel-newSimulation" />
                        </OKButton>
                    </div>
                    <div>
                        <OKButton
                            modifier="primary"
                            onClick={this.handleEditSaveSimulation}
                        >
                            <FormattedText value="raSaveSimulationModel-continueSimulation" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                content={contentModal}
                isOpen={isModalOpen}
                onCloseCallback={this.handleCloseSaveSimulation}
                shouldCloseOnOverlayClick={false}
                titleAlignment="center"
            />
        );
    }
}

RASaveSimulationModal.propTypes = {
    deleteSimulation: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    isObjective: PropTypes.bool.isRequired,
    immSaveSimulation: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    link: PropTypes.string.isRequired,
    onModalClose: PropTypes.func.isRequired,
    resetValueOfSaveSimulation: PropTypes.func.isRequired,
};

module.exports = withRouter(RASaveSimulationModal);
